import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { setupAxiosInterceptors } from './components/utils/setupAxiosInterceptors.js';
import { msalInstanceAzureAD, msalInstanceAzureADB2C } from "./components/utils/msalInstances.js";
import { MsalInstancesProvider } from "./components/utils/MsalInstancesContext.js";
import "./globalStyles/styles.css";
setupAxiosInterceptors();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalInstancesProvider
      azureADInstance={msalInstanceAzureAD}
      b2cInstance={msalInstanceAzureADB2C}
    >
      <App />
    </MsalInstancesProvider>
  </React.StrictMode>
);
reportWebVitals();


